import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import strings from "../../config/localization";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useGetAuditLogsQuery } from "../../services/appln";
import Grid from "@mui/material/Grid";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import { Typography } from "@mui/material";
import SearchButton from "../../components/Buttons/SearchButton";
import GeneralFailure from "../../components/GeneralFailure";
import { useNavigate } from "react-router-dom";
import { getRowsPerPage } from "../constants";

export default function AuditPanel() {
  const navigate = useNavigate();
  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());
  const [searchTerm, setSearchTerm] = React.useState("");

  const getParams = {
    page: count,
    limit: rowPerPage,
    search: searchTerm,
  };

  const { data, error, isLoading, isFetching } =
    useGetAuditLogsQuery(getParams);

  if (error) {
    return (
      <GeneralFailure
        title={strings.error}
        message={strings.failedToLoadAuditLogs}
      />
    );
  }

  const columns = [
    {
      field: "userId",
      headerName: strings.userId,
      width: 300,
    },
    {
      field: "userName",
      headerName: strings.userName,
      width: 300,
    },
    {
      field: "action",
      headerName: strings.action,
      width: 300,
    },
    {
      field: "parameters",
      headerName: strings.parameters,
      width: 800,
    },
    {
      field: "timestamp",
      headerName: strings.timestamp,
      width: 200,
    },
  ];

  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom component="div">
              {" "}
              {strings.auditLogs}{" "}
            </Typography>
          </Grid>
          {isLoading || isFetching ? (
            <Grid item xs={12}>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <SearchButton
              onClickHandler={(searchTerm: string) => {
                setCount(1);
                setSearchTerm(searchTerm);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={data?.data ? data?.data : []}
                columns={columns}
                onRowClicked={(params: any, _events: any, _details: any) => {
                  navigate(`../audit/${params.id}`);
                }}
              />

              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
